(function () {
  /* ── Desktop dropdown — hover з затримкою ── */
  var navItems = document.querySelectorAll('[data-vz-nav] .vz-nav__item.has-children');
  var closeTimer = null;

  navItems.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      navItems.forEach(function (i) { i.classList.remove('is-open'); });
      item.classList.add('is-open');
    });

    item.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () {
        item.classList.remove('is-open');
      }, 80);
    });

    var panel = item.querySelector('[data-vz-nav-panel]');
    if (panel) {
      panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      panel.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () {
          item.classList.remove('is-open');
        }, 80);
      });
    }
  });

  /* ── Mobile drawer ── */
  var drawer = document.querySelector('[data-vz-drawer]');
  if (!drawer) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    document.body.classList.add('vz-no-scroll');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.body.classList.remove('vz-no-scroll');
  }

  // Burger — intercept theme's aria-controls="nav" click
  var burger = document.querySelector('[data-burger]');
  if (burger) {
    burger.addEventListener('click', function (e) {
      // Only intercept on mobile
      if (window.innerWidth < 990) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openDrawer();
      }
    }, true); // capture phase — fires before theme JS
  }

  // Close triggers
  drawer.querySelectorAll('[data-vz-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  // Accordion rows
  drawer.querySelectorAll('[data-vz-drawer-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var row = btn.closest('.vz-drawer__row');
      if (!row) return;
      // Close others
      drawer.querySelectorAll('.vz-drawer__row.is-open').forEach(function (r) {
        if (r !== row) r.classList.remove('is-open');
      });
      row.classList.toggle('is-open');
    });
  });

  // Esc key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      navItems.forEach(function (i) { i.classList.remove('is-open'); });
    }
  });
})();
